const StudentsTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 80 },
    { id: 'full_name', labelAr: 'الاسم', labelEn: 'Name' },
    { id: 'gender', labelAr: 'الجنس', labelEn: 'Gender', width: 80 },
    { id: 'age', labelAr: 'العمر', labelEn: 'Age', width: 70 },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone', width: 120 },
    { id: 'memorized_parts_count', labelAr: 'الأجزاء', labelEn: 'Parts', width: 70 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 80 },
];

export default StudentsTableColumns;
